/* eslint-disable no-template-curly-in-string */
import { bool, object, string } from 'yup';
import { translateAndCastToString } from '../../../../utils';
import { CustomPaymentMethodFormValues } from './types';

export const customPaymentMethodValidationSchema = object().shape<CustomPaymentMethodFormValues>({
    name: string()
        .min(2, translateAndCastToString('Too Short!'))
        .max(50, translateAndCastToString('Too Long!'))
        .required(translateAndCastToString('Required')),
    isActive: bool()
});
